import React from "react";
import styles from "../SearchGraphView.module.css";

export const CustomLoader = () => (
  <div className={styles.customLoaderContainer}>
    <img src="/images/button_rocket.svg" alt="rocket" />
  </div>
);
